import React from "react";
import InputField from "../shared_components/input-field/InputField";
import SelectField from "../shared_components/select-field/SelectField";
import TextButton from "../shared_components/text-button";
import useCases from "../use_cases";
import User from "../presentation_models/user/user";
import ErrorMessage from "../shared_components/error-message/ErrorMessage";
import validators from "../utilities/form_validators";
import IUpgradeTeacherProFormState from "../interfaces/iupgrade_teacher-To_pro_form_state.type";
import IFieldName from "../interfaces/Ifield_name.type";
import IValidator from "../interfaces/ivalidator.type";
import { IEntity } from "../results/Entity";
import { Environment } from "../app/App";
import './UpgradeTeacherProForm.scss'

export const validatorMap: Record<IFieldName, IValidator> = {
    email: validators.validateEmail,
    date: validators.validateDateAfterToday
}

// eventually this component will use entity passed from user's main search selection rather than a user-inputted email
type UpgradeToProTeacherProps = {
    entity: IEntity | null,
    environment: Environment,
}

class UpgradeTeacherProForm extends React.Component<UpgradeToProTeacherProps, IUpgradeTeacherProFormState> {
    state: IUpgradeTeacherProFormState

    constructor(props: any) {
        super(props);
        this.state = {
            email: '',
            date: '',
            message: undefined,
            error: '',
            userData: undefined,
            contractInfo: undefined,
            validFields: { email: false, date: false },
            isFormValid: false
        }
    }

    createContractRequest = () => {
        if (this.state.userData) {
            const fullName = this.state.userData ? this.state.userData.getFullName() : ''
            const requestBody = {
                "plan": "niagara",
                "name": fullName + ' teacher contract',
                "expires": new Date(this.state.date).toISOString()
            }
            useCases.createNewContract(requestBody, {
                receiveContractInfo: this.receiveContractInfo,
                receiveContractError: this.receiveContractError
            });
        }
    }


    addToContract = () => {
        if (this.state.contractInfo && this.state.userData) {
            useCases.addUserToContract(this.state.contractInfo.getId(), this.state.userData.getId(),
                {
                    userAddedToContract: this.userAddedToContract,
                    userAddedToContractError: this.userAddedToContractError
                });
        }
    }

    /*------------------- Observers -------------------*/


    receiveUserInfo = (userInfo: User) => {
        this.setState({ userData: userInfo }, this.createContractRequest)
    }

    receiveUserError = () => {
        this.setState({
            error: 'UserData - Sorry, User not found. Please try again'
        });
    }

    receiveContractInfo = (contract: any) => {
        this.setState({ contractInfo: contract }, this.addToContract)
    }

    receiveContractError = () => {
        this.setState({
            error: 'ContractInfo - Sorry an error occurred while creating the contract. Please try again'
        });
    }

    userAddedToContract = (message: any) => {
        this.setState({
            email: '',
            date: '',
            message: message
        });
    }

    userAddedToContractError = () => {
        this.setState({
            error: 'AddUserToContract - Sorry an error occurred while adding the user to the contract. Please try again'
        });
    }


    /*------------------- Private -------------------*/

    validateField = (name: IFieldName, value: any) => {
        let isFieldValid = validatorMap[name](value)
        if (isFieldValid) {
            this.setState({
                validFields: { ...this.state.validFields, [name]: isFieldValid }
            }, this.isValid)
        } else {
            this.setState({
                isFormValid: false
            });
        }
    }

    isValid = () => {
        const { email, date } = this.state.validFields;
        if (email && date) {
            this.setState({
                isFormValid: true,
                error: ''
            });
        }
    }

    handleInputValue = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = event.target
        this.setState({ ...this.state, [name]: value })
        this.validateField(name as IFieldName, value);
    }

    handleSubmit = (event: React.BaseSyntheticEvent) => {
        if (event) event.preventDefault();

        useCases.finderUser({ email: this.state.email }, {
            receiveUserInfo: this.receiveUserInfo,
            receiveUserError: this.receiveUserError
        });
    }

    render() {

        const { email, date, message, validFields, error } = this.state;
        const { environment, entity } = this.props
        const today = new Date().toISOString().split('T')[0];

        return (
            <>
                <form onSubmit={this.handleSubmit} data-testid='upgrade-teacher-pro-form' className='.upgrade-to-pro-form-container'>
                    <InputField
                        id='email-input'
                        name='email'
                        label='Email'
                        type='text'
                        className='input-field'
                        handleChange={this.handleInputValue}
                        value={email}
                        testId='form-email'
                        isValid={validFields.email}
                        errorMessage='Invalid email input, please try again.'
                    />
                    <InputField
                        id='date-input'
                        name='date'
                        label='Expiration Date'
                        type='date'
                        className='input-field'
                        min={today}
                        handleChange={this.handleInputValue}
                        value={date}
                        testId='form-date'
                        isValid={validFields.date}
                        errorMessage='Invalid date input, please try again.'
                    />
                    <TextButton
                        disabled={!this.state.isFormValid}
                        variant='primary'
                        type='submit'
                        buttonText="Submit"
                        testId='form-submit'
                    />
                </form>
                {error && (
                    <ErrorMessage message={error} id='UTP-error-div' className='error-div' testId='UTP-error-div-testId' />
                )}
                {message && (<div role='status'>{message}</div>)}
            </>
        );
    }
}

export default UpgradeTeacherProForm;
